module.exports = __webpack_public_path__ + "static/media/IMG_0406.80c66b99.JPG";